import { TruckOutlined } from '@ant-design/icons';
import { lazyRouteComponent } from '@tanstack/react-router';

import { ACCOUNT_ROLE_CODES } from '@lib/types';
import { Route } from '@lib/types/route';

import { ROUTE_PATHS } from '../route-paths';

const ShippingSettingsPage = lazyRouteComponent(
  () => import('./pages/settings'),
);

export const getRoutes = (): Route[] => [
  {
    page: ShippingSettingsPage,
    path: ROUTE_PATHS.ADMIN_SHIPPING,
    title: 'Fretes',
    icon: TruckOutlined,
    acl: [ACCOUNT_ROLE_CODES.ADMIN],
    adminSection: 'platform',
    adminOrder: 10,
  },
];
